/*
AI Product Core

负责:
- Frame状态
- Frame图片切换
- Frame UI状态
- Variant同步入口

*/


window.artConfig={

    selectedFrame:"black",

    frameImages:{

        white:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_2.jpg?v=1784042691",

        espresso:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_4.jpg?v=1784042691",

        black:"https://cdn.shopify.com/s/files/1/0677/1117/2800/files/frame-color_3.jpg?v=1784042692"

    }

};




function updateFrame(color,element=null){


    console.log(
        "updateFrame:",
        color
    );



    const container=document.getElementById(
        "frame-display-container"
    );


    if(!container){
        console.error(
            "Frame container not found"
        );
        return;
    }



    window.artConfig.selectedFrame=color;



    const image=
    window.artConfig.frameImages[color];



    if(image){

        container.style.backgroundImage=
        `url('${image}')`;

    }



    const map={

        black:"Frame Black",

        white:"Frame White",

        espresso:"Frame Espresso"

    };




    const isFramed=
    document.getElementById(
        "frame-toggle-switch"
    )?.checked;




    if(window.AI_VARIANT_MANAGER){


        window.AI_VARIANT_MANAGER.select({

            option1:
            isFramed
            ?
            map[color]
            :
            "Canvas Only"

        });


    }else{


        console.error(
            "AI_VARIANT_MANAGER missing"
        );


    }





    const hiddenInput=
    document.getElementById(
        "cart-frame-input"
    );


    if(hiddenInput){

        hiddenInput.value=color;

    }





    if(element){


        document
        .querySelectorAll(
            ".frame-swatch"
        )
        .forEach(
            s=>{

                s.classList.remove(
                    "active-swatch"
                );

            }
        );



        element.classList.add(
            "active-swatch"
        );

    }



}








document.addEventListener(
"DOMContentLoaded",
function(){


    const initialColor=
    window.artConfig.selectedFrame;



    const defaultButton=
    document.querySelector(
        `.frame-swatch[onclick*="${initialColor}"]`
    );



    if(defaultButton){

        updateFrame(
            initialColor,
            defaultButton
        );

    }



});